export default "__VITE_ASSET__CVhNZJBb__"